export const redirectFromPaymentEvent = (event, url: string) => {
    // console.log('redirectFromPaymentEvent2', event, url)
    // window.top.history.replaceState('', '', url)
    // window.top.location.reload()
    // Voir s'il faut viser la fenêtre parent ou enfant => normalement le code est excécuté dans la fenêtre parent donc window.location
    window.location.href = url
}
